module.exports = __webpack_public_path__ + "img/bildende_hoehere_schule.57e4e02.svg";